let ENVIROMENT = window.location.hostname.replace(/^([^-]+)-.*$/ig, '$1');
if (ENVIROMENT === 'isso.vipkid.com.cn') {
  ENVIROMENT = 'prod'
}

if (ENVIROMENT === 'test' && process.env.NODE_ENV === 'development') {
  ENVIROMENT = process.env.VUE_APP_ENVIRONMENT;
}

const CONFIGINFO = {
  [ENVIROMENT]: {
    // login: `//pre-i-api-sso.vipkid.com.cn`
    // login: `//api.${ENVIROMENT}-sso.vipkid-qa.com.cn`
    login: `//test-mgt.vipkid-qa.com.cn/sso`,
    loginimg: `//api.stage-sso.vipkid-qa.com.cn`
    // login: `//172.23.31.20:11051`
  },
  pre: {
    login: '//pre-i-api-sso.vipkid.com.cn'
    // login: '//pre-mgt.vipkid.com.cn/sso'
  },
  prod: {
    login: '//i-api-sso.vipkid.com.cn'
    // login: '//api-mgt.vipkid.com.cn/sso'
  }
};

const hostsUrl = CONFIGINFO[ENVIROMENT];

export default Object.assign({}, {
  ENVIROMENT, CONFIGINFO
}, hostsUrl);
